module.exports = __webpack_public_path__ + "img/playShowreel.f9f09d20.svg";